import type { PropsWithChildren, LiHTMLAttributes } from 'react'
import dayjs from 'dayjs'
import styled from 'styled-components'

import { Text } from '../../../components/text'

import { Color } from '../../../theme/color'

export function NotificationList({ children }: { children: any }) {
  return <List>{children}</List>
}

export function NotificationItem({ children, ...props }: PropsWithChildren<LiHTMLAttributes<HTMLLIElement>>) {
  return <Item {...props}>{children}</Item>
}

function ItemType({ children }: { children: string }) {
  return (
    <Text className="notification-type" size={14} weight={600} color="text_secondary">
      [{children}]
    </Text>
  )
}
function Title({ children }: { children: string }) {
  return (
    <Text className="notification-title" size={16} weight={500}>
      {children}
    </Text>
  )
}
function Date({ children }: { children: string }) {
  return (
    <Text className="notification-date" size={12} color="text_secondary">
      {dayjs(children).format('YYYY-MM-DD')}
    </Text>
  )
}

const List = styled.ul`
  padding: 0 24px;
`

const Item = styled.li`
  display: flex;
  flex-direction: column;
  padding 16px 0;
  border-bottom: 1px solid ${Color.line};
  & > .notification-type {
    margin-bottom: 6px; 
  }
  & > .notification-title {
    margin-bottom: 8px;
    text-overflow: ellipsis;
    white-space: pre;
  }
`

NotificationItem.Type = ItemType
NotificationItem.Title = Title
NotificationItem.Date = Date
